import { useState } from 'react';

import { Step } from '@ui';
import { parseNumber } from '@utils';

import { IFormMobiProps } from './types';
import { RegistrationForm, Sms } from './components';
import { useCheckMobiQuery, useGetLogoMobiQuery, useSendOtpQuery } from './api';

export const FormMobi = ({
  checkout,
  typeTransaction,
  isTokenization = false,
  enterAmount,
}: IFormMobiProps) => {
  const [phone, setPhone] = useState<string>('');
  const [initialStep, setInitialStep] = useState<number>(0);

  const handleNextStep = (): void => {
    setInitialStep(initialStep + 1);
  };

  const handlePrevStep = (): void => {
    setInitialStep(initialStep - 1);
  };

  const { mutate: checkMobi, isPending } = useCheckMobiQuery(isTokenization);
  const { mutate: sendOtp, isPending: isPendingSendOtp } =
    useSendOtpQuery(isTokenization);

  const handleSetValuePhone = (phone: string): void => {
    setPhone(phone);
  };

  return (
    <div className="-ml-[150px] -mr-[150px] mt-5 rounded-xl bg-white p-24 sm:m-auto sm:rounded-none sm:px-6 sm:py-5">
      <Step
        initialStep={initialStep}
        steps={[
          <RegistrationForm
            key="registrationForm"
            isTokenization={isTokenization}
            isLoading={isPending}
            checkMobi={checkMobi}
            checkout={checkout || undefined}
            typeTransaction={typeTransaction || ''}
            handleNextStep={handleNextStep}
            handleSetValuePhone={handleSetValuePhone}
            enterAmount={enterAmount}
          />,
          <Sms
            key="sms"
            isTokenization={isTokenization}
            phone={phone}
            sendOtp={sendOtp}
            checkMobi={checkMobi}
            isLoading={isPendingSendOtp}
            handlePrevStep={handlePrevStep}
          />,
        ]}
      />
    </div>
  );
};
